import type { SitemapRow, SitemapDiagnostic } from "~/server/sitemap-explorer/types"

function csvCell(value: string | number | null | undefined) {
  const text = String(value ?? "")
  const safe = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text
  return `"${safe.replaceAll('"', '""')}"`
}

export function sitemapDiagnosticsToCsv(issues: SitemapDiagnostic[]) {
  return (
    "code,severity,source_sitemap,example_url,message,count\r\n" +
    issues
      .map(i =>
        [i.code, i.severity, i.sourceSitemap, i.url, i.message, i.count].map(csvCell).join(","),
      )
      .join("\r\n") +
    "\r\n"
  )
}

export function sitemapRowsToCsv(rows: SitemapRow[]): string {
  return `${[
    "url,lastmod,source_sitemap,changefreq,priority,discovered_via,depth",
    ...rows.map(row =>
      [
        row.url,
        row.lastmod,
        row.sourceSitemap,
        row.changefreq,
        row.priority,
        row.discoveredVia,
        row.depth,
      ]
        .map(csvCell)
        .join(","),
    ),
  ].join("\r\n")}\r\n`
}
